const fdaDenovoTheme = {
  dot: "bg-violet-400",
  accentText: "text-violet-200",
  subtleText: "text-violet-300",
  tabActive: "border-violet-400/40 bg-violet-500/10 text-violet-100",
  selectedRow: "border-l-2 border-violet-400 bg-violet-500/[0.08]",
  accentBadge: "border border-violet-400/30 bg-violet-500/10 text-violet-100",
  idBadge: "border border-violet-400/25 bg-violet-500/5 text-violet-100",
  detailBorder: "border-violet-400/25",
  detailGlow: "from-violet-400/25",
  checkbox:
    "border-violet-300/35 text-violet-200 hover:border-violet-200/55 hover:bg-violet-950/70 focus-visible:ring-violet-300/25",
  checkboxChecked:
    "border-violet-100/70 from-violet-300 to-fuchsia-400 shadow-[0_0_0_1px_rgba(221,214,254,0.16),0_10px_22px_rgba(139,92,246,0.24)]",
};

export default fdaDenovoTheme;
